import { CardBody } from '@stenajs-webui/elements';
import type { FC, ReactNode } from 'react';
import {
  BookingDetailsSectionHeader,
  type BookingDetailsSectionHeaderProps,
} from './BookingDetailsSectionHeader';

interface BookingDetailsSectionProps extends BookingDetailsSectionHeaderProps {
  children?: ReactNode;
  disablePadding?: boolean;
}

export const BookingSection: FC<BookingDetailsSectionProps> = ({
  title,
  disablePadding = false,
  children,
}) => (
  <>
    <BookingDetailsSectionHeader title={title} />

    {disablePadding ? children : <CardBody gap={3}>{children}</CardBody>}
  </>
);
